module.exports = __webpack_public_path__ + "img/single-post-img3-150x150.fc04dd58.jpg";